import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionPayment from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* payment(action) {
  try {
    const response = yield call(() => 
      API.post(ROUTES.API_PAYMENT, action.payload)
    );
    yield put(actionPayment.videoPaymentSaveSuccess(response));
  } catch (error) {
    yield put(actionPayment.videoPaymentSaveFailed({
      type: actionTypes.VIDEO_PAYMENT_SAVE_FAILED,
      errors: error.response?.data?.errors || [],
      status: 422
    }));
  }
}

function* paymentSaga() {
  yield takeLatest(actionTypes.VIDEO_PAYMENT_SAVE_REQUEST, payment);
}

export default paymentSaga;
